import React, { Component } from 'react';

class Format extends Component  {

    static formatarMoeda (valor, localidade = 'pt-BR', moeda = 'BRL') {
        return new Intl.NumberFormat(localidade, {
            style: 'currency',
            currency: moeda,
        }).format(valor);
    }

}

export default Format;